import { observer } from 'mobx-react';
import React, { ReactNode, useState, MouseEvent, JSX } from 'react';
import { Card, CardBody, CardImg, Col, Row } from 'reactstrap';

export interface Props {
  image?: string;
  placeholderImage: string;
  imageBottom?: ReactNode;
  headline?: ReactNode;
  topRight?: ReactNode;
  center?: ReactNode;
  bottomLeft?: ReactNode;
  button?: ReactNode;
  footer?: ReactNode;
  onClick?: (e: MouseEvent<HTMLSpanElement>) => void;
  fullAreaClick?: boolean;
}

const ListItemLayout = observer(
  (props: Props): JSX.Element => {
    const {
      placeholderImage,
      imageBottom,
      headline,
      topRight,
      center,
      bottomLeft,
      button,
      footer,
      onClick,
      fullAreaClick
    } = props;
    const [image, setImage] = useState<string>(props.image || '');

    return (
      <>
        <Card
          className={`list-item-layout${fullAreaClick ? ' list-item-layout--full-area' : ''}`}
          onClick={(e): void => (fullAreaClick && onClick ? onClick(e) : undefined)}
        >
          <Row noGutters>
            <Col md={4} className="list-item-layout__wrapper">
              {image && (
                <>
                  <CardImg
                    className="list-item-layout__wrapper__img"
                    src={image}
                    variant="top"
                    alt="Picture"
                    onError={(): void => setImage(placeholderImage)}
                  />
                  <div className="list-item-layout__wrapper__description">{imageBottom}</div>
                </>
              )}
              {!image && (
                <CardImg
                  className="iso__three-column-list-item-layout__wrapper__img"
                  src={placeholderImage}
                  variant="top"
                  alt="Picture"
                />
              )}
            </Col>
            <Col md={8}>
              <CardBody className="list-item-layout__content d-flex flex-column">
                {headline ||
                  (topRight && (
                    <Row>
                      <Col md={6}>
                        <div className="list-item-layout__content__headline mt-2">
                          <span
                            onClick={(e): void =>
                              !fullAreaClick && onClick ? onClick(e) : undefined
                            }
                          >
                            <h4>{headline}</h4>
                          </span>
                        </div>
                      </Col>
                      <Col md={6} className="d-flex justify-content-md-end py-3 py-md-0">
                        <div>{topRight}</div>
                      </Col>
                    </Row>
                  ))}
                <Row className="mt-1 mb-1 flex-grow-1">
                  <Col>
                    <div>{center}</div>
                  </Col>
                </Row>
                <Row>
                  {!!bottomLeft && (
                    <Col xs={!!button ? 6 : 12} className="py-3 py-md-0">
                      <div>{bottomLeft}</div>
                    </Col>
                  )}
                  {!!button && (
                    <Col
                      xs={!!bottomLeft ? 6 : 12}
                      className="d-flex justify-content-md-end align-items-center"
                    >
                      <div>{button}</div>
                    </Col>
                  )}
                </Row>
              </CardBody>
            </Col>
          </Row>
          {!!footer && (
            <Row noGutters>
              <Col>{footer}</Col>
            </Row>
          )}
        </Card>
      </>
    );
  }
);

export default ListItemLayout;
